import { CPF } from 'cpf_cnpj';

const CAMPO_OBRIGATORIO = 'Campo obrigatório';

const obrigatorio = valor => {
  if (!valor)
    return CAMPO_OBRIGATORIO;
};

const validarCpf = cpf => {
  if (!CPF.isValid(cpf))
    return 'CPF inválido';
};

const MENSAGEM_DATA_INVALIDA = 'Data de nascimento inválida';
const MENSAGEM_DATA_FUTURA = 'A data de nascimento não pode ser uma data futura.';
const MENSAGEM_MENOR_DE_IDADE = 'É preciso ter 18 anos ou mais';

const validarDataDeNascimento = (valor) => {
  const texto = valor == null ? '' : String(valor).trim();
  if (!texto)
    return CAMPO_OBRIGATORIO;

  const partes = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(texto);
  if (!partes)
    return MENSAGEM_DATA_INVALIDA;

  const dia = Number(partes[1]);
  const mes = Number(partes[2]);
  const ano = Number(partes[3]);
  const nascimento = new Date(ano, mes - 1, dia);
  if (nascimento.getFullYear() !== ano || nascimento.getMonth() !== mes - 1 || nascimento.getDate() !== dia)
    return MENSAGEM_DATA_INVALIDA;

  const hoje = inicioDoDia(new Date());
  if (nascimento > hoje)
    return MENSAGEM_DATA_FUTURA;

  if (idadeEmAnosCompletos(nascimento, hoje) < 18)
    return MENSAGEM_MENOR_DE_IDADE;
};

const inicioDoDia = (data) => new Date(data.getFullYear(), data.getMonth(), data.getDate());

const ehBissexto = (ano) => (ano % 4 === 0 && ano % 100 !== 0) || ano % 400 === 0;

const idadeEmAnosCompletos = (nascimento, hoje) => {
  const aniversario = aniversarioNoAno(nascimento, hoje.getFullYear());
  let idade = hoje.getFullYear() - nascimento.getFullYear();
  if (hoje < aniversario)
    idade -= 1;
  return idade;
};

const aniversarioNoAno = (nascimento, ano) => {
  const mes = nascimento.getMonth();
  const dia = nascimento.getDate();
  if (mes === 1 && dia === 29 && !ehBissexto(ano))
    return new Date(ano, 1, 28);
  return new Date(ano, mes, dia);
};

const validarRequisitosDaSenha = (senha) => {
  const quantidadeMinimaDeCaracteres = 6;
  const quantidadeMaximaDeCaracteres = 16;

  if (senha.length > quantidadeMaximaDeCaracteres)
    return 'A senha não pode conter mais de 16 caracteres';

  if (senha.length < quantidadeMinimaDeCaracteres || !contemNumero(senha) || !contemCaractere(senha))
    return 'A senha não atende as exigências mínimas';
};

function validarConfirmacaoDeSenha() {
  const { senha, confirmacaoDeSenha } = this;

  if (senha !== confirmacaoDeSenha)
    return 'As senhas não são iguais';
}

const contemNumero = (palavra) => {
  return /\d/.test(palavra);
};

const contemCaractere = (palavra) => {
  return /[a-z]/i.test(palavra);
};

const validacoes = {
  cpf: [obrigatorio, validarCpf],
  cidade: [obrigatorio],
  dataDeNascimento: [validarDataDeNascimento],
  senha: [obrigatorio, validarRequisitosDaSenha],
  confirmacaoDeSenha: [obrigatorio, validarConfirmacaoDeSenha],
};

const aplicarFuncoesDeValidacao = (contexto, campo, valor) => {
  const funcoes = validacoes[campo];
  const retornosComErro = funcoes.map(f => f.call(contexto, valor)).filter(r => !!r);

  return retornosComErro[0];
};

const validarCampo = (dadosDoCadastro, campo, valor) =>
  aplicarFuncoesDeValidacao(dadosDoCadastro, campo, valor);

const validarFormulario = dadosDoCadastro => {
  const erros = {};

  Object.keys(validacoes).map(campo => {
    const erro = aplicarFuncoesDeValidacao(dadosDoCadastro, campo, dadosDoCadastro[campo]);

    if (erro)
      erros[campo] = erro;
  });

  return erros;
};

export default { validarCampo, validarFormulario };